module.exports = __webpack_public_path__ + "static/twitter_white-3ff48b87ca8bdf55ee75b610d68d857e.png";